import l10n from "@/services/l10n";
import store from "@/store";

import { USER_GROUP_PERSON } from "@/constants";

export default ({ title = l10n("CREATE_PLAYLIST"), tracks, active = true }) => {
  return {
    active,
    authModal: true,
    title,
    icon: "add",
    accessLevel: [USER_GROUP_PERSON],
    action() {
      store.dispatch("playlists/create", {
        tracks
      });
    }
  };
};
